import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from '../../services/apiClient';

export const listAdminUsers = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, value);
  });
  return apiGet(`/api/admin/users${query.toString() ? `?${query.toString()}` : ''}`);
};

export const createAdminUser = (payload) => apiPost('/api/admin/users', payload);
export const updateAdminUser = (id, payload) => apiPut(`/api/admin/users/${id}`, payload);
export const updateAdminUserStatus = (id, payload) => apiPatch(`/api/admin/users/${id}/status`, payload);
export const deleteAdminUser = (id) => apiDelete(`/api/admin/users/${id}`);
export const assignAdminRoles = (id, payload) => apiPost(`/api/admin/users/${id}/assign-roles`, payload);
export const getAdminUserRoles = (id) => apiGet(`/api/admin/users/${id}/roles`);

export const listRoles = () => apiGet('/api/admin/roles');
export const createRole = (payload) => apiPost('/api/admin/roles', payload);
export const updateRole = (id, payload) => apiPut(`/api/admin/roles/${id}`, payload);
export const deleteRole = (id) => apiDelete(`/api/admin/roles/${id}`);
export const listPermissions = () => apiGet('/api/admin/permissions');
export const listAuditLogs = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, value);
  });
  return apiGet(`/api/admin/audit-logs${query.toString() ? `?${query.toString()}` : ''}`);
};
